import { CLOSE_ERROR_BAR, SHOW_ERROR_BAR } from '../constants/actions';
import { ERROR } from '../constants/error-severities';

const DEFAULT_ERROR_BAR_STATE = {
  message: '',
  severity: ERROR,
  callback: null,
  clickAction: null,
  primaryButtonLabel: '',
  onPrimaryAction: null,
  bannerId: null,
  actionHref: null,
  showing: false,
};

const errorBarReducer = (state = DEFAULT_ERROR_BAR_STATE, action) => {
  switch (action.type) {
    case CLOSE_ERROR_BAR:
      return DEFAULT_ERROR_BAR_STATE;
    case SHOW_ERROR_BAR:
      return {
        ...state,
        message: action.message,
        severity: action.severity,
        callback: action.callback,
        clickAction: action.clickAction,
        onPrimaryAction: action.onPrimaryAction,
        primaryButtonLabel: action.primaryButtonLabel,
        actionHref: action.actionHref,
        bannerId: action.bannerId,
        showing: true,
      };
    default:
      return state;
  }
};

export default errorBarReducer;
